import React, { useState, useEffect } from "react";
import { usePFDataContext } from "../context/PfContext";

const CartIcon = ({ id, name, brand, price }) => {
    const { pfData, updatePfData } = usePFDataContext();

    // Get product from cart (if it exists)
    const cartProduct = pfData.cart.products.find((item) => item.id === id);
    
    // Use local state for input value when the item is not in cart
    const [quantity, setQuantity] = useState(cartProduct ? cartProduct.qty : 1);

    // Sync with cart when cart updates
    useEffect(() => {
        if (cartProduct) {
            setQuantity(cartProduct.qty);
        }
    }, [pfData]);

    const handleQuantityChange = (e) => {
        const value = Math.max(1, Math.min(100, parseInt(e.target.value) || 1));
        setQuantity(value); // Update local state first

        if (cartProduct) {
            // Update quantity in global cart if product is already added
            const cart = { ...pfData.cart };
            const existingProductIndex = cart.products.findIndex((item) => item.id === id);
            if (existingProductIndex >= 0) {
                cart.products[existingProductIndex].qty = value;
                cart.products[existingProductIndex].total = value * cart.products[existingProductIndex].price;
                updatePfData("cart", cart);
            }
        }
    };

    const addToCart = () => {
        const cart = { ...pfData.cart };
        const existingProductIndex = cart.products.findIndex((item) => item.id === id);

        if (existingProductIndex >= 0) {
            // If product already exists, update the quantity
            cart.products[existingProductIndex].qty += quantity;
            cart.products[existingProductIndex].total =
                cart.products[existingProductIndex].qty * cart.products[existingProductIndex].price;
        } else {
            // Add new product to the cart
            const cartItem = {
                id,
                qty: quantity,
                name,
                brand,
                price,
                total: price * quantity,
            };
            cart.products.push(cartItem);
        }

        // Update the cart in the context
        updatePfData("cart", cart);
    };

    return (
        <>
            <input
                type="number"
                min="1"
                max="100"
                value={quantity}
                onChange={handleQuantityChange}
                className="product__list-row--cart--quantity"
            />
            <svg
                width="24px"
                height="24px"
                viewBox="0 0 16 16"
                xmlns="http://www.w3.org/2000/svg"
                role="img"
                aria-label="Cart Icon"
                onClick={addToCart}
            >
                <path
                    fill="#444"
                    d="M14 13.1v-1.1h-9.4l0.6-1.1 9.2-0.9 1.6-6h-12.3l-0.7-3h-3v1h2.2l2.1 8.4-1.3 2.6v1.5c0 0.8 0.7 1.5 1.5 1.5s1.5-0.7 1.5-1.5-0.7-1.5-1.5-1.5h7.5v1.5c0 0.8 0.7 1.5 1.5 1.5s1.5-0.7 1.5-1.5c0-0.7-0.4-1.2-1-1.4zM4 5h10.7l-1.1 4-8.4 0.9-1.2-4.9z"
                />
            </svg>
        </>
    );
};

export default CartIcon;
